import { MenuItem, styled } from "@mui/material";

import { background, button } from "@/modules/irohana-components/theme/colors-new";

/** Shared menu item styling for SelectNew and SelectMultiNew. Overrides the MuiMenu theme defaults. */
export const StyledMenuItem = styled(MenuItem)`
  &.MuiMenuItem-root {
    &:hover {
      background-color: ${background.base} !important;
    }
    &.Mui-selected {
      color: ${button.primary};
      font-weight: 500;
      background-color: ${background.secondary} !important;
      &:hover,
      &.Mui-focusVisible {
        background-color: ${background.secondary} !important;
      }
    }
  }
`;
